import { useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { DocumentChatMessageStatus } from 'shared/domains/apollo/generated/types';
import { useActiveDocument } from 'shared/domains/documents';
import { getLastChatQuery } from './query';
import { stringToReact } from './utils';
const ONE_SECOND = 1000;
const POLL_INTERVAL = 0.5 * ONE_SECOND;
export function useGetLastDocumentChat() {
    const { id: documentId } = useActiveDocument();
    const query = useQuery(getLastChatQuery, {
        variables: {
            documentId,
        },
    });
    const { lastChat } = query.data || {};
    const { messages = [], resolutionStatus, resolved = false } = lastChat || {};
    const thread = messages.map(message => (Object.assign(Object.assign({}, message), { html: message.content ? stringToReact(message.content) : undefined })));
    const shouldPoll = Boolean(thread.find(message => message.status === DocumentChatMessageStatus.Pending));
    useEffect(() => {
        if (shouldPoll) {
            query.startPolling(POLL_INTERVAL);
            return () => query.stopPolling();
        }
        return undefined;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldPoll]);
    return {
        chatId: lastChat === null || lastChat === void 0 ? void 0 : lastChat.id,
        thread,
        loading: query.loading,
        refetch: query.refetch,
        polling: shouldPoll,
        resolved,
        resolutionStatus,
    };
}
export { getLastChatQuery, ChatFragment, MessageFragment } from './query';
